import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useRouter } from '../../hooks/useRouter.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { adjustHref } from '../../utils/adjustHref.js';
import { Headline } from '../Headline/Headline.js';
import { getPaddings } from './getPaddings.js';
export const Video = JSX(({ className, title, url, previewImg, ...rest }) => {
    const router = useRouter();
    return (_jsxs(BlockWrapper, { className: className, defaultPadding: getPaddings(className), ...rest, children: [_jsx(Headline, { title: title, headlineVersion: "M" }), url ? (_jsx("video", { className: "m-auto w-full object-fill", preload: "metadata", poster: adjustHref(router)(previewImg?.src), style: { maxHeight: 524 }, controls: true, children: _jsx("source", { src: adjustHref(router)(url) }) })) : null] }));
});
//# sourceMappingURL=Video.js.map